// formulář objednávky
function orderFormSk() {
  $('#insurance_subject_order_type_0').click(function () {
    $('.bike-drivers').removeClass('is-hidden');
    $('.e-bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    $('.form-name-text').attr('placeholder', 'např. Honza kolo');
    $('.form-price-text').attr('placeholder', 'např. 30 990');
    $('.price-label-holder').html(
      '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete kolo pojistit?\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
    $('.name-label-holder').html(
      '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
  });

  $('#insurance_subject_order_type_1').click(function () {
    $('.e-bike-drivers').removeClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    $('.form-name-text').attr('placeholder', 'např. Jana elektrokolo');
    $('.form-price-text').attr('placeholder', 'např. 50 990');
    $('.price-label-holder').html(
      '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete elektrokolo pojistit?\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
    $('.name-label-holder').html(
      '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
  });

  $('#insurance_subject_order_type_2').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').removeClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    $('.form-name-text').attr('placeholder', 'např. Maty koloběžka');
    $('.form-price-text').attr('placeholder', 'např. 15 490');
    $('.price-label-holder').html(
      '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete koloběžku pojistit?\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
    $('.name-label-holder').html(
      '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
  });

  $('#insurance_subject_order_type_3').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').removeClass('is-hidden');
    $('.trailer-drivers').addClass('is-hidden');
    $('.form-name-text').attr('placeholder', 'např. Patrik e-koloběžka');
    $('.form-price-text').attr('placeholder', 'např. 24 990');
    $('.price-label-holder').html(
      '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete e-koloběžku pojistit?\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
    $('.name-label-holder').html(
      '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
  });

  $('#insurance_subject_order_type_4').click(function () {
    $('.e-bike-drivers').addClass('is-hidden');
    $('.bike-drivers').addClass('is-hidden');
    $('.scooter-drivers').addClass('is-hidden');
    $('.e-scooter-drivers').addClass('is-hidden');
    $('.trailer-drivers').removeClass('is-hidden');
    $('.form-name-text').attr('placeholder', 'např. Tobík cyklovozík');
    $('.form-price-text').attr('placeholder', 'např. 15 490');
    $('.price-label-holder').html(
      '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete cyklovozík pojistit?\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
    $('.name-label-holder').html(
      '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
        '                      <wow-tooltip class="wowtooltip">\n' +
        '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
        '                        <span class="icon icon--icon-info-blank">\n' +
        '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
        '                        </span>\n' +
        '                        </div>\n' +
        '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
        '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
        '                        </div>\n' +
        '                      </wow-tooltip>\n' +
        '                    </label>'
    );
  });

  $('.select2').select2();

  $(document).ready(function () {
    if ($('.order-2').length) {
      // scroll na sekci coinsurance
      $('html, body').animate(
        {
          scrollTop: $('#subject-coinsurances').offset().top,
        },
        800,
        function () {}
      );
    }

    // zajištění načtených hodnot a schování/zobrazení správných polí
    let chosenSubjectType = $(
      "input[name='insurance_subject_order[type]']:checked"
    ).val();
    chosenSubjectType = parseInt(chosenSubjectType);
    if (chosenSubjectType == 1) {
      $('.bike-drivers').removeClass('is-hidden');
      $('.e-bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      $('.form-name-text').attr('placeholder', 'např. Honza kolo');
      $('.form-price-text').attr('placeholder', 'např. 30 990');
      $('.price-label-holder').html(
        '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete kolo pojistit?\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
      $('.name-label-holder').html(
        '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
    }
    if (chosenSubjectType == 2) {
      $('.e-bike-drivers').removeClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      $('.form-name-text').attr('placeholder', 'např. Jana elektrokolo');
      $('.form-price-text').attr('placeholder', 'např. 50 990');
      $('.price-label-holder').html(
        '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete elektrokolo pojistit?\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
      $('.name-label-holder').html(
        '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
    }
    if (chosenSubjectType == 3) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').removeClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      $('.form-name-text').attr('placeholder', 'např. Maty koloběžka');
      $('.form-price-text').attr('placeholder', 'např. 15 490');
      $('.price-label-holder').html(
        '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete koloběžku pojistit?\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
      $('.name-label-holder').html(
        '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
    }
    if (chosenSubjectType == 4) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').removeClass('is-hidden');
      $('.trailer-drivers').addClass('is-hidden');
      $('.form-name-text').attr('placeholder', 'např. Patrik e-koloběžka');
      $('.form-price-text').attr('placeholder', 'např. 24 990');
      $('.price-label-holder').html(
        '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete e-koloběžku pojistit?\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
      $('.name-label-holder').html(
        '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
    }
    if (chosenSubjectType == 5) {
      $('.e-bike-drivers').addClass('is-hidden');
      $('.bike-drivers').addClass('is-hidden');
      $('.scooter-drivers').addClass('is-hidden');
      $('.e-scooter-drivers').addClass('is-hidden');
      $('.trailer-drivers').removeClass('is-hidden');
      $('.form-name-text').attr('placeholder', 'např. Tobík cyklovozík');
      $('.form-price-text').attr('placeholder', 'např. 15 490');
      $('.price-label-holder').html(
        '<label class="label-help price-label required" for="insurance_subject_order_purchasePrice">Na kolik chcete cyklovozík pojistit?\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
      $('.name-label-holder').html(
        '<label for="insurance_subject_order_name" class="label-help required">Pojmenujte předmět pojištění\n' +
          '                      <wow-tooltip class="wowtooltip">\n' +
          '                        <div class="wowtooltip__label" data-tooltip-placeholder>\n' +
          '                        <span class="icon icon--icon-info-blank">\n' +
          '                          <svg class="icon__svg"><use xlink:href="#icon-info-blank"></use></svg>\n' +
          '                        </span>\n' +
          '                        </div>\n' +
          '                        <div class="wowtooltip-dropdown" data-tooltip-dropdown>\n' +
          '                          <div role="tooltip" class="wowtooltip-dropdown__content">Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sint molestias, cumque corporis amet eaque incidunt nemo quos commodi quas, natus, architecto aliquid laborum iusto ad accusantium ea inventore quae id.</div>\n' +
          '                        </div>\n' +
          '                      </wow-tooltip>\n' +
          '                    </label>'
      );
    }

    /*    $("input[type='text']").change(function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });*/

    let customSelect = $('.custom-select');
    customSelect.on('click', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectBike = $('#insurance_subject_order_manufacturerBike');
    selectBike.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectEBike = $('#insurance_subject_order_manufacturerEBike');
    selectEBike.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectScooter = $('#insurance_subject_order_manufacturerScooter');
    selectScooter.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectEScooter = $('#insurance_subject_order_manufacturerEScooter');
    selectEScooter.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });

    let selectTrailer = $('#insurance_subject_order_manufacturerTrailer');
    selectTrailer.on('change', function () {
      $('#subject-coinsurances').addClass('is-hidden');
      $('#recalculate_Button').removeClass('is-hidden');
    });
  });
}
